import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "../styles/tailwind.css";
import { CustomerApp } from "../routes/catalogue/CustomerApp";

const container = document.getElementById("root");

if (container) {
  createRoot(container).render(
    <StrictMode>
      <CustomerApp />
    </StrictMode>,
  );
}
